import { useState, useEffect } from 'react';

/**
 * Custom hook for managing browser fullscreen functionality
 * @returns Object containing fullscreen state and control functions
 */
export const useBrowserFullscreen = () => {
  const [isInFullscreen, setIsInFullscreen] = useState(false);

  const isFullscreen = () => {
    return !!(document.fullscreenElement || (document as any).webkitFullscreenElement || (document as any).msFullscreenElement);
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsInFullscreen(isFullscreen());
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  const requestFullscreen = (element: HTMLElement) => {
    setIsInFullscreen(true);
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if ((element as any).webkitRequestFullscreen) {
      (element as any).webkitRequestFullscreen();
    } else if ((element as any).msRequestFullscreen) {
      (element as any).msRequestFullscreen();
    }
  };

  const exitFullscreen = () => {
    setIsInFullscreen(false);
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
  };

  return {
    isInFullscreen,
    isFullscreen,
    requestFullscreen,
    exitFullscreen,
  };
};

